import { j as m } from "./jsx-runtime-944c88e2.js";
import { Button as j } from "./button.js";
import * as c from "react";
import { p as n } from "./index-efd35e77.js";
import { c as u, b as p, d as P } from "./Enums-2eefd6e1.js";
import { v as R, c as l, p as x } from "./package-metadata-a152adb8.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
import "./Ripple-5a8cf54c.js";
import "./icon.js";
var f = globalThis && globalThis.__assign || function() {
  return f = Object.assign || function(e) {
    for (var s, t = 1, a = arguments.length; t < a; t++) {
      s = arguments[t];
      for (var r in s)
        Object.prototype.hasOwnProperty.call(s, r) && (e[r] = s[r]);
    }
    return e;
  }, f.apply(this, arguments);
}, A = globalThis && globalThis.__rest || function(e, s) {
  var t = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && s.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
      s.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (t[a[r]] = e[a[r]]);
  return t;
}, y = c.forwardRef(function(e, s) {
  var t;
  R(x);
  var a = e.children, r = e.dir, o = e.style, i = e.className, d = e.type, E = e.orientation, $ = A(e, ["children", "dir", "style", "className", "type", "orientation"]), h = c.useRef(null), g = c.useRef(null);
  return c.useImperativeHandle(h, function() {
    return {
      element: g.current,
      props: e
    };
  }), c.useImperativeHandle(s, function() {
    return h.current;
  }), c.createElement("div", f({ dir: r, style: o, ref: g, className: l("k-card", i, (t = {}, t["k-card-".concat(d)] = d !== p.DEFAULT, t), E !== u.HORIZONTAL ? "k-card-vertical" : "k-card-horizontal") }, $), a);
});
y.displayName = "KendoReactCard";
y.propTypes = {
  children: n.node,
  className: n.string,
  dir: n.string,
  orientation: n.oneOf(["horizontal", "vertical"]),
  style: n.object,
  type: n.oneOf(["default", "primary", "info", "success", "warning", "error"])
};
y.defaultProps = {
  type: p.DEFAULT,
  orientation: u.VERTICAL
};
var b = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-header", e.className) }, e.children);
};
b.propTypes = {
  className: n.string
};
var C = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-title", e.className) }, e.children);
};
C.propTypes = {
  className: n.string
};
var T = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-body", e.className) }, e.children);
};
T.propTypes = {
  className: n.string
};
var N = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-actions", e.className, "k-card-actions-".concat(e.layout), e.orientation !== u.VERTICAL ? "k-card-actions-horizontal" : "k-card-actions-vertical") }, e.children);
};
N.propTypes = {
  layout: n.oneOf(["stretched", "start", "center", "end"]),
  orientation: n.oneOf(["horizontal", "vertical"])
};
N.defaultProps = {
  layout: P.START,
  orientation: u.HORIZONTAL
};
var v = function(e) {
  return c.createElement("img", { style: e.style, className: l("k-card-image", e.className), src: e.src });
};
v.propTypes = {
  className: n.string,
  src: n.string
};
v.defaultProps = {
  src: ""
};
var k = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-subtitle", e.className) }, e.children);
};
k.propTypes = {
  className: n.string
};
var O = function(e) {
  return c.createElement("div", { style: e.style, className: l("k-card-footer", e.className) }, e.children);
};
O.propTypes = {
  className: n.string
};
const V = (e) => {
  const { hoverEffects: s, clickable: t, ...a } = e, r = s || t, o = r ? "redstone-card" : "", i = a.className ? `${a.className} ${o}` : o, d = /* @__PURE__ */ m.jsx(y, { ...a, className: i });
  return r ? /* @__PURE__ */ m.jsx(
    j,
    {
      style: {
        height: "auto",
        padding: "0px"
      },
      themeColor: "secondary",
      children: d
    }
  ) : d;
}, Z = N, K = T, M = (e) => {
  const { hoverEffects: s, clickable: t, ...a } = e, o = s || t ? "redstone-card-footer" : "", i = a.className ? `${a.className} ${o}` : o;
  return /* @__PURE__ */ m.jsx(O, { ...a, className: i });
}, q = (e) => {
  const { hoverEffects: s, clickable: t, ...a } = e, o = s || t ? "redstone-card-header" : "", i = a.className ? `${a.className} ${o}` : o;
  return /* @__PURE__ */ m.jsx(b, { ...a, className: i });
}, G = v, J = k, Q = C;
export {
  V as Card,
  Z as CardActions,
  K as CardBody,
  M as CardFooter,
  q as CardHeader,
  G as CardImage,
  J as CardSubtitle,
  Q as CardTitle
};
